// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"logo_scroll-black__Hz7WO","logo":"logo_logo__c0Vn3","big":"logo_big__wkQ0Q"};